import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Button, Form, Card, InputGroup } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import { API } from '../../App';
import { toast } from 'react-toastify';
import Switch from 'react-switch';
import Cookies from 'js-cookie';
import Fancybox from '../../Component/FancyBox';

const KeyboardCategoriesEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [IsSelected, setIsSelected] = useState(false);
    const [selectedfile, setSelectedfile] = useState(null);
    const [category, setCategory] = useState({
        name: '',
        // image: '',
        status: true
    });

    const { name } = category;

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const token = Cookies.get('jwt');
                const res = await API.post(`/keyboardCategories/${id}`,{}, {
                    headers: { "authorization": `Bearer ${token}` }
                });
                if (res.data.response_code === 200) {
                    setCategory(res.data.data);
                } else {
                    navigate('/keyboardcatgory');
                }
            } catch (error) {
                console.error('Error fetching category:', error);
                navigate('/keyboardcatgory');
            }
        };
        fetchCategory();
    }, [id, navigate]);

    const handleSubmission = async () => {
        if (!name) {
            toast.error('Name is required', { position: 'bottom-right' });
            return;
        }

        const formdata = new FormData();
        formdata.append('name', name);
        // if (selectedfile) {
        //     formdata.append('image', selectedfile);
        // }
        formdata.append('status', category.status);

        setLoading(true);
        try {
            const token = Cookies.get('jwt');
            const res = await API.post(`/keyboardCategories/update/${id}`, formdata, {
                headers: {
                    "authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            });
            if (res.data.status === true) {
                navigate(`/keyboard/category/view/${id}`);
                toast.success('Category updated successfully', { position: 'bottom-right', autoClose: 500 });
            }
        } catch (error) {
            toast.error('Error updating category', { position: 'bottom-right' });
        } finally {
            setLoading(false);
        }
    };

    const onInputChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.value });
    };

    // const handleFileChange = (event) => {
    //     setSelectedfile(event.target.files[0]);
    //     setIsSelected(true);
    // };

    const handleStatusChange = (checked) => {
        setCategory({ ...category, status: checked });
    };

    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3>Edit Keyboard Category</h3>
            </div>
            <div className="page-content">
                <Form>
                    <Row>
                        <Col xs={12}>
                            <Card className="mb-4">
                                <Card.Body>
                                    {loading && <div className="loader table-loader"></div>}
                                    <Row>
                                        <Col lg={4} sm={12}>
                                            <Form.Group>
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={name}
                                                    onChange={onInputChange}
                                                    placeholder="Enter category name"
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* <Col lg={4} sm={12}>
                                            <Form.Group>
                                                <Form.Label>Image</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type="file"
                                                        name="image"
                                                        onChange={handleFileChange}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Col> */}
                                        <Col lg={4} sm={12}>
                                            <Form.Label className="d-block mb-2">Status</Form.Label>
                                            <Switch
                                                onChange={handleStatusChange}
                                                checked={category.status}
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={<div className="react-switch-off">OFF</div>}
                                                checkedIcon={<div className="react-switch-on">ON</div>}
                                            />
                                        </Col>
                                    </Row>
                                </Card.Body>
                                <Card.Footer className="text-end">
                                    <Button variant="primary" className="me-3" onClick={handleSubmission} disabled={loading}>
                                        {loading ? 'Saving...' : 'Save'}
                                    </Button>
                                    <Link to="/keyboardcatgory">
                                        <Button variant="secondary">Cancel</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Layout>
    );
};

export default KeyboardCategoriesEdit;